import { environment } from '@core/environment';
import { GrpcRestFetchTransport, RpcRestError, useAuth0Interceptor } from '@deepup/api-utils';
import {
  isupportApiV1 as supportApi,
  isupportClientApiV1 as supportClientApi,
} from '@deepup/internal-apis';
import { useMemo } from 'react';

const DEFAULT_ERROR_MESSAGE = 'Issue reporting failed';

export const usePostSupportTicket = () => {
  const authInterceptor = useAuth0Interceptor();

  const client = useMemo(() => {
    const transportRest = new GrpcRestFetchTransport({
      baseUrl: environment.unifiedApiUrl,
      fetchInit: {
        credentials: 'include',
      },
      interceptors: [authInterceptor],
    });

    return new supportClientApi.InternalSupportServiceClient(transportRest);
  }, [authInterceptor]);

  const postSupportTicket = async (payload: supportApi.CreateSupportTicketRequest) => {
    try {
      return await client.createSupportTicket(payload).response;
    } catch (err) {
      if (err instanceof RpcRestError) {
        return err.body && err.body.message ? err.body.message : DEFAULT_ERROR_MESSAGE;
      } else {
        return DEFAULT_ERROR_MESSAGE;
      }
    }
  };

  return { postSupportTicket };
};
